import { render, staticRenderFns } from "./WarningComponent.vue?vue&type=template&id=153df3b3&scoped=true"
import script from "./WarningComponent.vue?vue&type=script&lang=js"
export * from "./WarningComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153df3b3",
  null
  
)

export default component.exports